import NewTemplateBroadcastPage from '../pages/dashboard/components/pages/NewTemplateBroadcastPage';

export default function NewTemplateBroadcastRoute() {
  return <NewTemplateBroadcastPage />;
}